import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './career-card.scss';

class CareerCard extends PureComponent {
  render() {
    return (
      <button type="button" onClick={this.props.onClick}>
        <div className="career-card">
          <div
            className="career-card-image"
            style={{ backgroundImage: `url(${this.props.previewImage})` }}
          />

          {(this.props.dateDisplay) &&
            <h5
              className="career-card-date"
              dangerouslySetInnerHTML={{ __html: this.props.dateDisplay }}
            />
          }

          {(this.props.jobTitle) &&
            <h2
              className="career-card-title"
              dangerouslySetInnerHTML={{ __html: this.props.jobTitle }}
            />
          }

          {(this.props.previewText) &&
            <p
              className="career-card-text"
              dangerouslySetInnerHTML={{ __html: this.props.previewText }}
            />
          }

          <div className="career-card-button">
            <div className="btn btn-arrowed">
              Подробнее <span className="icon">→</span>
            </div>
          </div>
        </div>
      </button>
    );
  }
}

CareerCard.propTypes = {
  previewImage: PropTypes.string,
  dateCreated: PropTypes.string,
  dateDisplay: PropTypes.string,
  jobTitle: PropTypes.string,
  previewText: PropTypes.string,
  onClick: PropTypes.func
};

export default CareerCard;



// WEBPACK FOOTER //
// ./src/components/Career/CareerCard.js